// extracted by mini-css-extract-plugin
export default {"header":"add-password-success__header","title":"add-password-success__title"};